import React from 'react';
import { Tab, TabTheme, Tabs } from '@vimily/bonjoro-ui-components-v2/Tabs';
import { CarouselHookProps } from '@vimily/bonjoro-ui-components-v2/Carousel';
import { PreviewTabIndex } from '.';

export function TabButtons({
  carouselProps,
}: {
  carouselProps: CarouselHookProps;
}) {
  return (
    <Tabs
      theme={TabTheme.Blue}
      active={carouselProps?.activeIndex ?? 0}
      className='w-full px-6'
      liButtonClassName='py-1 px-0'
    >
      <Tab
        title={
          <TabTitle
            icon='icon-record'
            label='Video'
            iconClassName='h-5 w-[22px]'
          />
        }
        onClick={() => carouselProps?.setActiveIndex(PreviewTabIndex.Record)}
      />
      <Tab
        title={
          <TabTitle icon='icon-email' label='Email' iconClassName='h-5 w-5' />
        }
        onClick={() => carouselProps?.setActiveIndex(PreviewTabIndex.Email)}
      />
      <Tab
        title={
          <TabTitle
            icon='icon-landing-pages'
            label='Landing page'
            iconClassName='h-[23px] w-[21px]'
          />
        }
        onClick={() =>
          carouselProps?.setActiveIndex(PreviewTabIndex.LandingPage)
        }
      />
    </Tabs>
  );
}

interface TabTitleProps {
  icon: string;
  iconClassName?: string;
  label: string;
}

function TabTitle({ icon, iconClassName = '', label }: TabTitleProps) {
  return (
    <div className='flex flex-row gap-x-2.5 items-center justify-center'>
      <i className={`icon ${icon} !v2-bg-black  ${iconClassName}`} />
      <span className='v2-text-neutral-900 font-normal'>{label}</span>
    </div>
  );
}
